import script from "./BindPhoneDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./BindPhoneDialog.vue?vue&type=script&setup=true&lang=js"

import "./BindPhoneDialog.vue?vue&type=style&index=0&id=6d5a4985&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d5a4985"]])

export default __exports__